import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import * as actions from '../../actions'
import { Desabandono0, Desabandono1 } from './steps'
import { FORM_DESABANDONO } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'
import StatusModal from
  '../../../Forms/SharedComponents/containers/StatusModal'
import { ToastContainer } from 'react-toastify'

const selector = formValueSelector(FORM_DESABANDONO)

class Desabandono extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  nextStep () {
    const {
      verificarDesabandono,
      desabandonoStep,
      numero
    } = this.props

    if (desabandonoStep === 0) {
      verificarDesabandono(numero)
    }
  }

  prevStep () {
    this.props.desabandonoPrevStep()
  }

  handleSubmit () {
    this.props.desabandonarCpa(this.props.destroy)
  }

  render () {
    const {
      desabandonoStep,
      show,
      desabandonoSaveResponse
    } = this.props

    return (
      <div className='camiones-abandono-container'>
        <StatusModal
          show={show}
          onClick={this.props.hideNoDesabandonable}
          errorMessage={desabandonoSaveResponse}
        />
        <h2>Desabandono de CPA</h2>
        {desabandonoStep === 0 && <Desabandono0 onSubmit={this.nextStep} />}
        {desabandonoStep === 1 &&
          <Desabandono1 onSubmit={this.handleSubmit} onPrev={this.prevStep} />}
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <div />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    numero: selector(state, 'numero'),
    desabandonoStep: state.camionesIngreso.desabandonoStep,
    show: state.camionesIngreso.desabandonoShowSaveModal,
    desabandonoSaveResponse: state.camionesIngreso.desabandonoSaveResponse
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({ form: FORM_DESABANDONO })(Desabandono)
)
